const UNKNOWN_WORDS_ORIGIN_FIELD_NAMES = {
  DISH_NAME: 'Dish Name',
  DISH_DESCRIPTION: 'Dish Description',
  DISH_INGREDIENTS_TEXT: 'Dish Ingredients Text',
  MENU_TITLE_NAME: 'Menu Title Name',
  MENU_TITLE_DESCRIPTION: 'Menu Title Description',
}

export default UNKNOWN_WORDS_ORIGIN_FIELD_NAMES
